import React from 'react';
import '../styles/HomePage.css';

const Features: React.FC = () => {
  return (
    <section className='features'>
      <div className='feature'>
        <h2>Discover</h2>
        <ul>
          <li>Priorities for your community, your command, and your service</li>
          <li>
            Research that has been done, is being done, and should be done
          </li>
          <li>
            Research, tools, data, subject matter experts, and other critical
            resources
          </li>
        </ul>
      </div>
      <div className='feature'>
        <h2>Connect</h2>
        <ul>
          <li>Service leadership</li>
          <li>Warfighters</li>
          <li>Faculty and students at military research universities</li>
          <li>Civilian engineers and scientists</li>
          <li>Industry-leading companies</li>
        </ul>
      </div>
      <div className='feature'>
        <h2>Collaborate</h2>
        <ul>
          <li>Using recently completed research for a running start </li>
          <li>
            Side-by-side with other practitioners, scientists, and engineers{' '}
          </li>
          <li>As part of a diverse and interdisciplinary team</li>
        </ul>
      </div>
      <div className='feature'>
        <h2>Deliver</h2>
        <ul>
          <li>Insights about priority problems </li>
          <li>
            All available resources to researchers, including industry partners,
            to help develop and deploy solutions
          </li>
          <li>Service members with critical hands-on experience </li>
          <li>Acceleration of concept and capability development</li>
        </ul>
      </div>
    </section>
  );
};

export default Features;
